<template>
    <div class="timerange">
        <div class="timerange-inputs">
            <div class="timerange-field">
                <span class="timerange-label">From</span>
                <select class="select-input" v-model="startVal" v-bind:class="{ 'text-input-error': field.has_error }">
                    <option value="">--:--</option>
                    <option v-for="time in fromOptions" :key="'from-' + time" :value="time">{{ time }}</option>
                </select>
            </div>
            <div class="timerange-arrow"><v-icon name="arrow-right"></v-icon></div>
            <div class="timerange-field">
                <span class="timerange-label">Until</span>
                <select class="select-input" v-model="endVal" v-bind:class="{ 'text-input-error': field.has_error }">
                    <option value="">--:--</option>
                    <option v-for="time in untilOptions" :key="'until-' + time" :value="time">{{ time }}</option>
                </select>
            </div>
            <span class="timerange-duration" v-if="duration">{{ duration }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['field', 'value'],
    computed: {
        interval: function () {
            const seconds = parseInt(this.field.options.step, 10) || 60
            return Math.max(1, Math.round(seconds / 60))
        },
        startMinutes: function () {
            const hour = parseInt(this.field.options.start_hour, 10)
            return Number.isFinite(hour) ? hour * 60 : 0
        },
        endMinutes: function () {
            const hour = parseInt(this.field.options.end_hour, 10)
            return Number.isFinite(hour) ? hour * 60 : 24 * 60
        },
        options: function () {
            const times = []
            for (let minutes = this.startMinutes; minutes <= this.endMinutes; minutes += this.interval) {
                times.push(this.format(minutes))
            }
            return times
        },
        fromOptions: function () {
            // The last slot is the end boundary, valid as an "until" but not as a "from".
            return this.options.slice(0, -1)
        },
        untilOptions: function () {
            if (!this.parsed.start) return this.options
            return this.options.filter(time => time >= this.parsed.start)
        },
        parsed: function () {
            const parts = typeof this.value === 'string' && this.value ? this.value.split(' - ') : []
            return { start: parts[0] || '', end: parts[1] || '' }
        },
        startVal: {
            get() {
                return this.parsed.start
            },
            set(val) {
                // Drop the "until" if it would now be earlier than the new "from".
                const end = this.parsed.end && this.parsed.end >= val ? this.parsed.end : ''
                this.emit(val, end)
            }
        },
        endVal: {
            get() {
                return this.parsed.end
            },
            set(val) {
                this.emit(this.parsed.start, val)
            }
        },
        duration: function () {
            const { start, end } = this.parsed
            if (!start || !end || end <= start) return null

            const minutes = this.toMinutes(end) - this.toMinutes(start)
            const hours = Math.floor(minutes / 60)
            const remainder = minutes % 60

            return [hours ? hours + 'h' : '', remainder ? remainder + 'm' : ''].filter(Boolean).join(' ')
        }
    },
    methods: {
        format: function (minutes) {
            const hours = Math.floor(minutes / 60)
            const remainder = minutes % 60
            return ('0' + hours).slice(-2) + ':' + ('0' + remainder).slice(-2)
        },
        toMinutes: function (time) {
            const [hours, minutes] = time.split(':').map(Number)
            return (hours * 60) + minutes
        },
        emit: function (start, end) {
            this.$emit('input', start || end ? start + ' - ' + end : '')
        }
    }
}
</script>
